let closeElement = document.getElementById("modal-close");
let closerLookModalElement = document.getElementById("closer-look-modal");
let openCloserLookModalelement = document.getElementById("open-closer-modal")

closeElement.addEventListener("click", () => {
  closerLookModalElement.classList.add("hidden")
});

openCloserLookModalelement.addEventListener("click", () => {
  closerLookModalElement.classList.remove("hidden")
});

// function tabSelector(e) {

// // Get the selected tab
// let tabOption = e.target;

// // Get the other sibling tabs
// otherTabs = getSiblings(tabOption.parentNode);

// // Go through all tabs and make sure that only the tab that was clicked has the selected-tab class
// tabOption.parentNode.classList.add("selected-tab");
// for (let indexOfTabs = 0; indexOfTabs < otherTabs.length; indexOfTabs++) {
//     const otherTab = otherTabs[indexOfTabs];
//     otherTab.classList.remove("selected-tab");
// }

// // Get a list of all the panels
// panelElements = document.getElementsByClassName("toggle-panel");

// // Go through them one by one and check only apply the hidden class to the panels not selected
// for (let indexOfSelection = 0; indexOfSelection < panelElements.length; indexOfSelection++) {
//     const panel = panelElements[indexOfSelection];
//     if (indexOfSelection == tabOption.attributes.value.value) {
//       panel.classList.remove("hidden");
//     } else {
//       panel.classList.add("hidden");
//     }
// }
// }

function accordionSelector(e) {
  let selection = e
    .currentTarget
    .attributes
    .value
    .value;

// e.currentTarget.classList.add("accordion-panel-expanded");
  let querySelectorString = '[data-accordion-panel="' + selection + '"]';
  console.log(querySelectorString);

  let firstIndex = 0;
  let panelToToggle = document.querySelectorAll(querySelectorString)[firstIndex];
  if (panelToToggle.classList.contains("accoridon-panel-expanded")) {
    panelToToggle.classList.remove("accoridon-panel-expanded");
  } else {
    panelToToggle.classList.add("accoridon-panel-expanded");
  }
}

// Helper function that reteives all the siblings of a node: https://www.javascripttutorial.net/javascript-dom/javascript-siblings/
function getSiblings(e) {
  let siblings = [];

  if (! e.parentNode) {
    return siblings;
  }

  let sibling = e.parentNode.firstChild;

  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== e) {
      siblings.push(sibling);
    }
    sibling = sibling.nextSibling;
  }
  return siblings;
}

// Splide for Closer Look Modal
var splideCloserLook;
$(function() {
  splideCloserLook = new Splide("#image-carousel", {
    type: "loop",
    gap: "2rem",
    perMove: 1,
    perPage: 1,
    pagination: false
  });

  splideCloserLook.mount();

});

function goToSlide(index) {
  closerLookModalElement.classList.remove("hidden");
  splideCloserLook.go(index);
}


// Splide for Included Items section
// `breakpoints` parameter below solves this problem:
// Changes number of slides displayed depending on screen size

$(function() {
  var splide2 = new Splide(".inlcuded-items", {
    type: "loop",

// focus: "center",
// height: "400px",
    width: "60%",

// fixedWidth: "75vw",
    gap: "2rem",
    perMove: 1,
    perPage: 5,
    pagination: false,
    breakpoints: {
      767: {
        perPage: 2
      }
    }

// padding: {
// right: "20%",
// left: "20%",
// },
  });

  var slide_indicator2 = document.querySelector("#slide_indicator2");

  function update_indicator() {
    slide_indicator2.innerHTML = `${
      splide2.index + 1
    } of ${
      splide2.length
    }`;
  }

  splide2.on("mounted", () => {
    update_indicator();
  });


  splide2.mount();

  splide2.on("moved", () => {
    update_indicator();
  });
});


// Splide for Large Gallery section
$(function() {
  var splide = new Splide(".splide", {
    type: "slide",
    focus: "center",
    heightRatio: .5,

// cover: true,
    width: "100%",
    fixedWidth: "65vw",
    gap: "3rem",
    pagination: false,
    padding: {
      right: "20%",
      left: "20%"
    }
  });

  var slide_indicator = document.querySelector("#slide_indicator");

  function update_indicator() {
    slide_indicator.innerHTML = `${
      splide.index + 1
    } of ${
      splide.length
    }`;
  }

  splide.on("mounted", () => {
    update_indicator();
  });

  splide.mount();

  splide.on("moved", () => {
    update_indicator();
  });
});

// Commercial Changing Words
let list = ["Wood", "Charcoal", "Gas"];
let counter = 0;
let word = document.getElementById("commercial-word");
let animate = setInterval(function() {
  word.innerHTML = list[counter];
  counter++;
  if (counter >= list.length) {
    counter = 0;
  }
}, 1000);
